import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  Input,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormControlDirective } from '@shared/reactive-controls/directives/base-form-control.directive';
import { HtmlSanitizer } from '@shared/reactive-controls/services/html-sanitizer.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { CULTURE_SERVICE, ICultureService } from '../../models/iculture-service.model';

@Component({
  selector: 'app-label-control',
  templateUrl: './label-control.component.html',
  styleUrls: ['./label-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LabelControlComponent),
      multi: true,
    },
    {
      provide: BaseFormControlDirective,
      useExisting: LabelControlComponent,
    },
  ],
})
export class LabelControlComponent extends BaseFormControlDirective {
  private _destroy$: Subject<boolean> = new Subject<boolean>();
  private _tagsWhitelist: string[] = [
    'h1',
    'h2',
    'h3',
    'h4',
    'p',
    'b',
    'strong',
    'i',
    'em',
    'mark',
    'small',
    'del',
    'ins',
    'sub',
    'sup',
  ];

  @Input() textAlignStyle: any;

  @Input() set text(v: string) {
    this.formControl.setValue(v);
  }

  constructor(
    private _change: ChangeDetectorRef,
    private _htmlSanitizer: HtmlSanitizer,
    @Inject(CULTURE_SERVICE) cultureService: ICultureService,
    injector: Injector,
  ) {
    super(cultureService, injector);

    this.formControl.valueChanges
      .pipe(
        takeUntil(this._destroy$),
        tap(() => this._change.markForCheck()),
      )
      .subscribe();
  }

  getSanitizedValue(value?: string): string {
    const preSanitizedValue = this.getFirstTagOnly(value);
    return this._htmlSanitizer.sanitize(preSanitizedValue, this._tagsWhitelist);
  }

  private getFirstTagOnly(value?: string): string {
    if (!value) return '';
    const htmlTagRegex: string = `<([^>]\+)(\?:[^<>]\+)\?>([\\s\\S]\*\?)<\\/\\1>\|<([^>]\+)(\?:[^<>]\+)\?>`;
    const htmlTagRegexp = new RegExp(htmlTagRegex);
    const valueContainsHtmlTag = htmlTagRegexp.test(value);
    if (!valueContainsHtmlTag) return value;
    const match = htmlTagRegexp.exec(value);
    return match[0];
  }
}
